<template>
  <div class="weui-cell" :class="{'weui-cell_wan': showWarn, 'disabled': disabled, 'weui-cell_vcode': showVcode }">
    <div v-if="label" class="weui-cell__hd">
      <label class="weui-label" v-html="label" />
    </div>
    <div class="weui-cell__bd">
      <slot>
        <input class="weui-input" :type="type" :value="value" @input="updateValue($event.target.value)" :placeholder="placeholder" :disabled="disabled">
      </slot>
    </div>
    <div class="weui-cell__ft" v-if="showVcode">
      <slot name="button" class="weui-vcode-btn" />
      <slot name="image" class="weui-vcode-img" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'Input',
    props: {
        label: {
            type: String,
            default: null,
        },
        showWarn: {
            type: Boolean,
            default: false,
        },
        showVcode: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number],
            default: null,
        },
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/input/Index.vue